import { RQService }                 from '../../RQuery/RQuery';
import { Component }                 from '@angular/core';
import { UnhandledExceptionHandler } from '../../services/UnhandledExceptions';
import { MLText }                    from '../../services/MLText';
import { AppDataBroker }             from '../../services/AppData';
import { NavController }             from 'ionic-angular';
import { SignInPage }                from '../sign-in/sign-in';
import { AppMenuViewModel }          from '../../app/xv-menu';

export class dmLoading {
    Show:        (pAction: () => void) => void;
    Dismiss:     ()                    => void;

    IsDismissed: boolean;

    constructor(
         pShow:    (pAction: () => void) => void
        ,pDismiss: ()                    => void
    ) {
        this.Show        = pShow;
        this.Dismiss     = pDismiss;

        this.IsDismissed = false;
    }
}

@Component({
   selector:    'page-loading'
  ,templateUrl: 'loading.html'
})
export class LoadingPage {
    constructor(
         exHandler:     UnhandledExceptionHandler
        ,mlText:        MLText
        ,navCtrl:       NavController
        ,appDataBroker: AppDataBroker
    ) {
        console.log('initialise loading');

        /* test network (call is redundant, only to check connectivity) and go to home screen */
        if (mlText.Initialised) {
            RQService.Pms.GetCCTypes({}).then((result) => {
                let response = result as any;

                if (response.HasErrorOrException) { return; }

                let appMenuViewModel: AppMenuViewModel
                    = appDataBroker.GetAppMenuViewModel() as AppMenuViewModel;

                appMenuViewModel.HasNetworkError = false;

                navCtrl.setRoot(SignInPage);
            });

            return;
        }

        /* init ml and go to home screen */
        mlText.InitialiseService(
             'BookingEngineAppTexts'
            ,'BookingEngineSignIn'
            ,() => {
                if (!exHandler.ExceptionsThrown) {
                    let appMenuViewModel: AppMenuViewModel
                        = appDataBroker.GetAppMenuViewModel() as AppMenuViewModel;

                    exHandler.SetMLInitialised();

                    appMenuViewModel.initialise();

                    appMenuViewModel.HasNetworkError = false;

                    navCtrl.setRoot(SignInPage);
                }
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/loading/loading.ts